/* 
 * we don't use react much on the client side (yet) 
 * so this just wraps up the realtime stuff into callbacks
 * this should only be used to update some angular features.
 * we should port those to react when we can 
 */

import RealtimeClient from './data/RealtimeClient';

class _ReactBridge {

    constructor() {
		this.fakeDispatch = this.fakeDispatch.bind(this);
		this.listeners = {};
		RealtimeClient.init(this.fakeDispatch,
							window.pageVariables.morty_token,
							window.pageVariables.user);
		
    }

    addListener(type, callback) {
		//	console.warn("ReactBridge.addListener(%s)", type);	
		if(Object.keys(this.listeners).indexOf(type) === -1)
			this.listeners[type] = [];
		this.listeners[type].push(callback);
    }

    fakeDispatch(obj) {
		let type = obj.type;
		//	console.warn("ReactBridge dispatching: (%o)", obj);
		if(Object.keys(this.listeners).indexOf(type) !== -1)
			this.listeners[type].map( (cb) => cb(obj.data) );
    }
}



if(!window._reactBridgeReady) {
    window._reactBridgeReady = true;
    window.ReactBridge = new _ReactBridge();
	//    console.warn("React Bridge Ready");
}
